module.exports = __webpack_public_path__ + "Activities.c4aba25fc23482f2adfe.png";